<template>
  <el-table-column
    prop="customer.name"
    sortable="custom"
    label="Vevő"
    show-overflow-tooltip
    min-width="200"
  >
    <template slot-scope="scope">
      {{ scope.row.customer_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'customer.name',
  };
</script>
